var path = 'app/scripts/modules/azure/src/serverGroup/configure/wizard/loadBalancers/loadBalancers.html';
var html = "<div class=\"row\">\n  <azure-server-group-load-balancers-selector command=\"command\"></azure-server-group-load-balancers-selector>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;